import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import authService from "../services/auth.service";

const ProtectedRoutes = () => {
  const { user, loading } = useSelector((state) => state.auth);
  const location = useLocation();
  const dispatch = useDispatch();

  if (loading) {
    return <div>Loading...</div>;
  }

  const storedUser = JSON.parse(localStorage.getItem("user"));
  const currentUser = user || storedUser;

  // User not logged in
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  const userData = currentUser.data || currentUser;
  const role = userData?.role?.toLowerCase();

  const path = location.pathname;

  const isAllowed =
    (role === "admin" && path.startsWith("/superadmin")) ||
    (role === "travel_admin" && path.startsWith("/admin")) ||
    (role === "staff" && path.startsWith("/admin")) ||
    (role === "hotel_owner" && path.startsWith("/hotel"));

  // Unauthorized user → logout
  if (!isAllowed) {
    authService.logout();

    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoutes;